<template>
  <div>
    <h1>
      <i class="fas fa-sync-alt refreshIcon" @click="refreshReports()"></i>
    </h1>
    <div class="selectReport">
      <button
        class="btn btn-sm btn-outline-dark reportTypeButton"
        @click="showUsersAndOrdersReport()"
      >
        Stosunek użytkowników zweryfikowanych do niezweryfikowanych
      </button>

      <button
        v-for="type in reportTypes"
        :key="type"
        class="btn btn-sm btn-outline-dark reportTypeButton"
        @click="getReport(type)"
        :style="type === 'REFERRAL_CODES' ? 'display: none' : ''"
      >
        <span v-if="type === 'REFERRAL_CODES'"
          >Liczba wykorzystanych kodów poszczególnych użytkowników</span
        >
        <span v-if="type === 'DATE_OF_BIRTH'"
          >Użytkownicy urodzeni w danym roku</span
        >
        <span v-if="type === 'WORK_STATUS'"
          >Użytkownicy z poszczególnymi statusami</span
        >
        <span v-if="type === 'USER_SERVICES'"
          >Liczba wybranych usług przez Opiekunów</span
        >
        <span v-if="type === 'USER_SERVICES_VERIFIED'"
          >Liczba wybranych usług przez Opiekunów zweryfikowanych</span
        >
        <span v-if="type === 'USER_SERVICES_PRICE'"
          >Średnia cena usług Opiekunów zweryfikowanych</span
        >
        <span v-if="type === 'LOCATION'">Użytkownicy z danej lokalizacji</span>
        <span v-if="type === 'LOCATION_CITY'">Użytkownicy z danego miasta</span>
        <span v-if="type === 'ORDERS'">Złożone zamówienia dla siebie</span>
        <span v-if="type === 'ORDERS_CRS'"
          >Złożone zamówienia dla osoby bliskiej</span
        >
        <span v-if="type === 'PAYMENT_TYPES'"
          >Liczba transakcji według typów płatności</span
        >
        <span v-if="type === 'PAYMENT_TYPES_AMOUNTS'"
          >Suma transakcji według typów płatności</span
        >
        <span v-if="type === 'SERVICE_SEARCH'"
          >Liczba wyszukań danej usługi</span
        >
      </button>
      <!-- DETAILED REPORTS -->
      <button
        class="btn btn-sm btn-outline-dark reportTypeButton"
        @click="showUserServicesInSpecifiedCitiesReport()"
      >
        Liczba usług opiekunów w poszczególnych miastach
      </button>

      <button
        class="btn btn-sm btn-outline-dark reportTypeButton"
        @click="showUsersAndUserServicesReport()"
      >
        Użytkownicy i zamawiane usługi
      </button>

      <button
        class="btn btn-sm btn-outline-dark reportTypeButton"
        @click="showPromotionalCodesReport()"
      >
        Kody promocyjne
      </button>
      <button
        class="btn btn-sm btn-outline-dark reportTypeButton"
        @click="showReferralCodesReport()"
      >
        Referrale
      </button>
      <button
        class="btn btn-sm btn-outline-dark reportTypeButton"
        @click="showOrdersRejectionReport()"
      >
        Zamówienia odrzucone
      </button>
      <button
        class="btn btn-sm btn-outline-dark reportTypeButton"
        @click="showUserSubscriptions()"
      >
        Subskrypcje użytkowników
      </button>
      <!-- <button
        class="btn btn-sm btn-outline-dark reportTypeButton"
        @click="showUserSubscriptionsOrders()"
      >
        Subskrypcje użytkowników - zamówienia
      </button> -->
      <button
        class="btn btn-sm btn-outline-dark reportTypeButton"
        @click="showUserRegulations()"
      >
        Regulaminy
      </button>

      <button
        class="btn btn-sm btn-outline-dark reportTypeButton"
        @click="showServiceRegulations()"
      >
        Regulaminy usług specjalnych
      </button>

      <button
        class="btn btn-sm btn-outline-dark reportTypeButton"
        @click="
          downloadStandardReport(
            `/api/admin/manuallyDeletedUsers/file`,
            'deleted_users.xls'
          )
        "
      >
        Ręcznie usunięci użytkownicy
      </button>

      <button
        class="btn btn-sm btn-outline-dark reportTypeButton"
        @click="showUsersActivity()"
      >
        Aktywność użytkowników
      </button>
      <button
        class="btn btn-sm btn-outline-dark reportTypeButton"
        @click="showAdminPermissionSettings()"
      >
        Uprawnienia administratorów
      </button>
      <button
        class="btn btn-sm btn-outline-dark reportTypeButton"
        @click="showTriedToLoginReport()"
      >
        Użytkownicy, którzy próbowali się zalogować
      </button>
      <button
        class="btn btn-sm btn-outline-dark reportTypeButton"
        @click="showProfileElementsReport('PROFILE_FEATURE')"
      >
        Więcej o użytkownikach
      </button>
      <button
        class="btn btn-sm btn-outline-dark reportTypeButton"
        @click="showHealthDataConsentsReport()"
      >
        Więcej o mnie - zgody na dane o zdrowiu
      </button>
      <button
        class="btn btn-sm btn-outline-dark reportTypeButton"
        @click="showProfileElementsReport('TRAINING')"
      >
        Szkolenia użytkowników
      </button>
      <button
        class="btn btn-sm btn-outline-dark reportTypeButton"
        @click="showProfileElementsReport('LANGUAGES')"
      >
        Języki użytkowników
      </button>

      <button
        class="btn btn-sm btn-outline-dark reportTypeButton"
        @click="showProfileElementsReport('CVS')"
      >
        Dodane CV
      </button>

      <button
        class="btn btn-sm btn-outline-dark reportTypeButton"
        @click="showSmsReport()"
      >
        Licznik SMS
      </button>
      <button
        class="btn btn-sm btn-outline-dark reportTypeButton"
        @click="showRecharges()"
      >
        Doładowania
      </button>
      <button
        class="btn btn-sm btn-outline-dark reportTypeButton"
        @click="showWalletBalances()"
      >
        Użytkownicy ze środkami w portfelu SAPP
      </button>
      <button
        class="btn btn-sm btn-outline-dark reportTypeButton"
        @click="showOrdersByStatusReport()"
      >
        Zamówienia według statusu
      </button>
      <button
        class="btn btn-sm btn-outline-dark reportTypeButton"
        @click="showUsersServicesByCityReport('', '', '', 'Łódź')"
      >
        Usługi opiekunów zweryfikowanych w poszczególnych miastach
      </button>
      <button
        class="btn btn-sm btn-outline-dark reportTypeButton"
        @click="showUsersReportFromAppReport()"
      >
        Zgłoszenia użytkowników
      </button>
      <button
        class="btn btn-sm btn-outline-dark reportTypeButton"
        @click="showDodBillsReport()"
      >
        Rachunki DOD
      </button>
      <button
        class="btn btn-sm btn-outline-dark reportTypeButton"
        @click="showInvoicesReport()"
      >
        Faktury
      </button>
    </div>

    <div class="reportTable" v-if="selectedType">
      <span v-if="selectedType"
        ><h4>
          <span v-if="type === 'REFERRAL_CODES'"
            >Liczba wykorzystanych kodów poszczególnych użytkowników</span
          >
          <span v-if="selectedType === 'DATE_OF_BIRTH'"
            >Użytkownicy urodzeni w danym roku</span
          >
          <span v-if="selectedType === 'WORK_STATUS'"
            >Użytkownicy z poszczególnymi statusami</span
          >
          <span v-if="selectedType === 'USER_SERVICES'"
            >Liczba wybranych usług przez Opiekunów</span
          >
          <span v-if="selectedType === 'USER_SERVICES_VERIFIED'"
            >Liczba wybranych usług przez Opiekunów zweryfikowanych</span
          >

          <div
            class="pl-0 mt-4"
            v-if="
              selectedType === 'USER_SERVICES_VERIFIED' ||
              selectedType === 'USER_SERVICES'
            "
          >
            Nazwa kolumny -> Kategoria - Podkategoria - Nazwa usługi (Opis
            usługi)
          </div>

          <span v-if="selectedType === 'USER_SERVICES_PRICE'"
            >Średnia cena usług użytkowników</span
          >
          <span v-if="selectedType === 'LOCATION'"
            >Użytkownicy z danej lokalizacji</span
          >
          <span v-if="selectedType === 'LOCATION_CITY'"
            >Użytkownicy z danego miasta</span
          >
          <span v-if="selectedType === 'ORDERS'"
            >Złożone zamówienia dla siebie</span
          >
          <span v-if="selectedType === 'ORDERS_CRS'"
            >Złożone zamówienia dla osoby bliskiej</span
          >
          <span v-if="selectedType === 'PAYMENT_TYPES'"
            >Liczba transakcji według typów płatności</span
          >
          <span v-if="selectedType === 'PAYMENT_TYPES_AMOUNTS'"
            >Suma transakcji według typów płatności</span
          >
          <span v-if="type === 'SERVICE_SEARCH'"
            >Liczba wyszukań danej usługi</span
          >
        </h4></span
      >

      <button
        class="btn btn-sm btn-outline-dark downloadButton"
        @click="downloadReport(selectedType)"
        v-if="selectedType"
      >
        Pobierz
      </button>

      <div class="reportDescription">
        <div
          v-if="
            selectedType === 'PAYMENT_TYPES' ||
            selectedType === 'PAYMENT_TYPES_AMOUNTS'
          "
        >
          <h6><b>Prowizja</b> - prowizja od zrealizowanej usługi</h6>
          <h6><b>Wypłata</b> - zrealizowana wypłata dla użytkownika</h6>
          <h6>
            <b>Opłata serwisowa</b> - kara za niezrealizowane lub odwołane
            zlecenie
          </h6>
          <h6><b>Wpłata</b> - doładowanie konto przez użytkownika</h6>
          <h6>
            <b>Zwrot dla seniora</b> - zwrot dla seniora (odrzucenia, rezygnacja
            lub niezrealizowanie zamówienia przez opiekuna, nieznalezienie
            opiekuna do zamówionej usługi przez seniora, rezygnacja seniora z
            zamówienia)
          </h6>
          <h6>
            <b>Wpływ</b> - dodanie pieniędzy na konto opiekuna za zrealizowaną
            usługę
          </h6>
          <h6><b>Weryfikacja+</b> - wpłata weryfikacyjna</h6>
          <h6><b>Weryfikacja-</b> - zwrot wpłaty weryfikacyjnej</h6>
          <h6><b>Płatność</b> - płatność seniora za zamówioną usługę</h6>
          <h6>
            <b>Dodana przez admina</b> - kwota dodana do portfela użytkownika z
            poziomu panelu administratora
          </h6>
          <h6 v-if="selectedType === 'PAYMENT_TYPES_AMOUNTS'">
            <b>Cofnięte doładowania od admina</b> - zwrot doładowań promocyjnych
            z kodów promocyjnych z powodu odrzucenia lub niezrealizowania
            zlecenia, dla którego został użyty kod
          </h6>
          <h6>
            <b>Suma wpłat przez BlueMedia</b> - suma zrealizowanych wpłat do
            systemu (doładowania portfela + płatności za zamówienie)
          </h6>
          <h6 v-if="selectedType === 'PAYMENT_TYPES_AMOUNTS'">
            <b>Suma pieniędzy na kontach użytkowników</b> - suma wpłat przez
            BlueMedia + dodane przez admina - (suma prowizji, opłat serwisowych,
            wypłat oraz cofniętych doładowań z wszystkich miesięcy)
          </h6>
          <br />

          <h6 v-if="selectedType === 'PAYMENT_TYPES_AMOUNTS'">
            <b
              >{{ frozenMoney ? Math.round(frozenMoney * 100) / 100 : 0 }}zł
            </b>
            - Aktywne zlecenia - (suma pieniędzy ze zleceń oczekujących,
            zaakceptowanych niezakończonych oraz niezrealizowanych oczekujących
            na decyzję admina)
          </h6>
          <h6 v-if="selectedType === 'PAYMENT_TYPES_AMOUNTS'">
            <b
              >{{
                waitingWithdraws ? Math.round(waitingWithdraws * 100) / 100 : 0
              }}zł
            </b>
            - Wypłaty oczekujące na zatwierdzenie
          </h6>
        </div>

        <div
          v-if="
            loadingPhoneNumbers && phoneNumbers && phoneNumbers.length === 0
          "
          style="visibility: visible"
          class="spinner-border text-secondary loader mb-4 mt-4"
          role="status"
        >
          <span class="sr-only">Loading...</span>
        </div>
        <div
          class="phoneNumbers"
          v-if="phoneNumbers && phoneNumbers.length > 0"
        >
          Numery telefonów użytkowników świadczących usługę:
          <b> {{ this.servicesWithUserPhoneNumbersService }}</b
          ><br />
          <span
            v-for="result in phoneNumbers"
            :key="result"
            class="phoneNumbersList"
          >
            <b>{{ result }}, </b>
          </span>
        </div>
      </div>
      <table class="table table-stiped">
        <thead>
          <tr
            class="tr-table"
            v-if="
              selectedType !== 'PAYMENT_TYPES' &&
              selectedType !== 'WORK_STATUS' &&
              selectedType !== 'PAYMENT_TYPES_AMOUNTS'
            "
          >
            <th>Miesiąc</th>
            <th v-for="result in Object.keys(columns)" :key="result">
              {{ result }}
            </th>
          </tr>

          <tr
            class="tr-table"
            v-if="
              selectedType === 'PAYMENT_TYPES' ||
              selectedType === 'PAYMENT_TYPES_AMOUNTS'
            "
          >
            <th>Miesiąc</th>
            <th v-for="result in Object.keys(columns)" :key="result">
              <span v-if="result === 'FROZEN_MONEY'">Zamrożone pieniądze</span>
              <span v-if="result === '07_DISCOUNTS_OF_REJECTED_ORDERS'"
                >Cofnięte doładowania od admina</span
              >
              <span v-if="result === '06_WITHDRAW'">Wypłata</span>
              <span v-if="result === '05_PENALTY'">Opłata serwisowa</span>
              <span v-if="result === '08.1_INCOME_PAYMENT_STANDARD'"
                >Wpłata na konta Opiekunów Standard</span
              >
              <span v-if="result === '08.2_INCOME_PAYMENT_BUSINESS'"
                >Wpłata na konta Partnerów "Chcę więcej"</span
              >
              <span v-if="result === 'ORDER_CUSTOMER_RETURN'"
                >Zwrot dla seniora</span
              >
              <span v-if="result === 'ORDER_EMPLOYEE'">Wpływ</span>
              <span v-if="result === 'ORDER_CUSTOMER_STANDARD'"
                >Płatność za usługi standardowe</span
              >
              <span v-if="result === 'ORDER_CUSTOMER_SPECIAL'"
                >Płatność za usługi Partnerów "Chcę więcej"</span
              >
              <span v-if="result === 'VERIFICATION'">Weryfikacja+</span>
              <span v-if="result === 'VERIFICATION_RETURN'">Weryfikacja-</span>
              <span v-if="result === '04.1_COMMISSION_STANDARD'"
                >Prowizja na usługach standard</span
              >
              <span v-if="result === '04.2_COMMISSION_SPECIAL'"
                >Prowizja na usługach Partnerów "Chcę więcej"</span
              >
              <span v-if="result === '03_PAYMENTS_FROM_ADMIN'"
                >Dodana przez admina</span
              >
              <span v-if="result === '02_ALL_PAYMENTS_BLUEMEDIA'"
                >Suma wpłat przez BlueMedia</span
              >
              <span v-if="result === '01_USERS_MONEY_IN_APP'"
                >Suma pieniędzy na kontach użytkowników</span
              >
            </th>
          </tr>

          <tr class="tr-table" v-if="selectedType === 'WORK_STATUS'">
            <th>Miesiąc</th>
            <th v-for="result in Object.keys(columns)" :key="result">
              <span v-if="result === 'STUDENT'"
                >Student poniżej 26 roku życia</span
              >
              <span v-if="result === 'UNEMPLOYED'">Osoba niepracująca</span>
              <span v-if="result === 'PENSIONER'">Emeryt/rencista</span>
              <span v-if="result === 'EMPLOYED'">Osoba pracująca</span>
              <span v-if="result === 'BUSINESS'">Właściciel firmy</span>
              <span v-if="result === 'NONE'">Brak statusu</span>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(result, index) in reportData" :key="index">
            <td class="dateColumn">
              {{ result.date }}
            </td>
            <td
              v-for="(result, index) in Object.values(
                reportData[index].results
              )"
              :key="index"
            >
              {{ result ? result : 0 }}
              <div
                v-if="
                  selectedType === 'USER_SERVICES_VERIFIED' ||
                  selectedType === 'USER_SERVICES'
                "
              >
                <i
                  class="fas fa-info-circle"
                  :class="[
                    phoneNumbers &&
                    phoneNumbers.length > 0 &&
                    servicesWithUserPhoneNumbersService === index
                      ? 'fa-times'
                      : 'fa-info-circle',
                  ]"
                  @click="
                    phoneNumbers &&
                    phoneNumbers.length > 0 &&
                    servicesWithUserPhoneNumbersService === index
                      ? clearServicesWithUserPhoneNumbersListReport()
                      : getServicesWithUserPhoneNumbersListReport($event, index)
                  "
                >
                </i>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="reportTable" v-if="userServicesInSpecifiedCitiesReport">
      <button
        class="btn btn-sm btn-outline-dark downloadButton"
        @click="
          downloadStandardReport(
            'api/admin/employeesInSpecificArea/file',
            'employeesInSpecificArea.xls'
          )
        "
      >
        Pobierz
      </button>
      <table class="table borderless">
        <thead>
          <tr class="tr-table">
            <th>
              <b>Liczba opiekunów zweryfikowanych</b>
            </th>
            <th
              v-for="(categoryName, index) in userServicesInSpecifiedCities"
              :key="index"
            >
              {{ categoryName.name }}
            </th>
          </tr>
        </thead>

        <tbody>
          <tr
            v-for="(
              employeeWithNumber, index
            ) in userServicesInSpecifiedCities[0].employeesNumberAndCity"
            :key="index"
          >
            <td>
              {{ employeeWithNumber.city }}
            </td>
            <td
              v-for="(categoryName, index) in userServicesInSpecifiedCities"
              :key="index"
            >
              {{
                getNumberOfEmployees(employeeWithNumber.city, categoryName.name)
              }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="reportTable" v-if="usersAndUserServicesReport">
      <button
        class="btn btn-sm btn-outline-dark downloadButton"
        @click="
          downloadStandardReport(
            'api/admin/totalUsersAndUserServices/file',
            'totalUsersAndUserServices.xls'
          )
        "
      >
        Pobierz
      </button>

      <table class="table borderless">
        <thead>
          <tr class="tr-table">
            <th>Miesiąc</th>
            <th>Zweryfikowanych opiekunów</th>
            <th>Wszystkich użytkowników</th>
            <th>Ilość usuniętych kont</th>
            <th>Ilość usuniętych kont Seniora</th>
            <th>Ilość usuniętych kont Opiekunów zweryfikowanych</th>
            <th>Ilość zamówionych usług (Seniora + CRS)</th>
            <th>Ile unikalnych użytkowników zamówiło</th>
          </tr>
        </thead>

        <tbody>
          <tr v-for="(item, index) in usersAndUserServices" :key="index">
            <td>{{ item.month }}</td>
            <td>{{ item.verified_users }}</td>
            <td>{{ item.all_users }}</td>
            <td>{{ item.deleted_accounts }}</td>
            <td>{{ item.deleted_senior_accounts }}</td>
            <td>{{ item.deleted_employee_accounts }}</td>
            <td>{{ item.ordered_services }}</td>
            <td>{{ item.unique_ordering_users }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="reportTable" v-if="promotionalCodesReport">
      <button
        class="btn btn-sm btn-outline-dark downloadButton"
        @click="
          downloadStandardReport(
            `api/admin/promotionalCodes/fileForAllMonths?only_used=${toggleOnlyUsedPromotionalCodes}`,
            'promotional_codes.xls'
          )
        "
      >
        Pobierz
      </button>

      <div class="flex-inline">
        <span class="toggle">
          <i
            class="fas fa-toggle-on"
            v-if="!toggleOnlyUsedPromotionalCodes"
            @click="handleToggle()"
          ></i>
          <span v-if="!toggleOnlyUsedPromotionalCodes"
            >Wszystkie przypisane kody promocyjne (wykorzystane lub
            niewykorzystane)</span
          >
          <i
            class="fas fa-toggle-off"
            v-if="toggleOnlyUsedPromotionalCodes"
            @click="handleToggle()"
          ></i>
          <span v-if="toggleOnlyUsedPromotionalCodes"
            >Tylko wykorzystane kody promocyjne</span
          >
        </span>
      </div>

      <table
        class="table borderless"
        v-for="month in promotionalCodes"
        :key="month"
      >
        <thead
          v-if="month.promotional_codes && month.promotional_codes.length > 0"
        >
          <tr class="tr-table">
            <th style="font-size: 20px">
              <b>{{ month.month }}</b>
            </th>
            <th>Kod promocyjny</th>
            <th>Ile razy wpisany</th>
            <th>Pobierz użytkowników</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(code, index) in month.promotional_codes" :key="index">
            <td></td>
            <td>{{ code.code }}</td>
            <td>{{ code.counter }}</td>
            <td>
              <button
                class="btn btn-outline-dark"
                @click="downloadPromotionalCodesReport(code.code, month.month)"
              >
                Pobierz
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="reportTable" v-if="referralCodesReport">
      <button
        class="btn btn-sm btn-outline-dark downloadButton"
        @click="
          downloadStandardReport(`api/admin/referrals/file`, 'referrals.xls')
        "
      >
        Pobierz
      </button>
      <table
        class="table borderless"
        v-for="month in promotionalCodes"
        :key="month"
      >
        <thead v-if="month.referral_codes && month.referral_codes.length > 0">
          <tr class="tr-table">
            <th style="font-size: 20px">
              <b>{{ month.month }}</b>
            </th>
            <th>Nr tel.</th>
            <th>Kod polecający</th>
            <th>Ile razy wpisany</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(code, index) in month.referral_codes" :key="index">
            <td></td>
            <td>{{ code.phone }}</td>
            <td>{{ code.code }}</td>
            <td>{{ code.counter }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="reportTable" v-if="ordersRejectionReport">
      <div class="flex-inline">
        <select @change="handleOrdersRejectionFilter($event)">
          <option value="all">Wszystkie</option>
          <option value="auto_rejected">Automatycznie odrzucone</option>
          <option value="user_rejected">Odrzucone przez użytkownika</option>
        </select>
      </div>
      <button
        class="btn btn-sm btn-outline-dark downloadButton"
        @click="
          downloadStandardReport(
            `api/admin/rejectedOrders/file?auto_rejected=${onlyAutoOrdersRejection}&user_rejected=${onlyUserOrdersRejection}`,
            'rejected_orders.xls'
          )
        "
      >
        Pobierz
      </button>

      <table class="table borderless">
        <thead>
          <tr class="tr-table">
            <th>Numer tel.</th>
            <th>Liczba odrzuceń</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in ordersRejection" :key="item.phone">
            <td>{{ item.user_phone }}</td>
            <td>{{ item.number_of_rejection }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="reportTable" v-if="userSubscriptions">
      <subscriptions-reports-view />
    </div>

    <div class="reportTable" v-if="userSubscriptionsOrders">
      <div class="df">
        <select
          @change="handleSubOrdersParamChange($event)"
          class="adjust-height"
        >
          <option value="">Wszystkie</option>
          <option
            v-for="param in filteringParams"
            :key="param.id"
            :value="param"
          >
            {{ param }}
          </option>
        </select>

        <div class="dates df">
          <div class="datepickers">
            <datepicker
              :monday-first="true"
              :language="pl"
              v-model="selectedDateFromSubOrders"
              name="dateFrom"
              :placeholder="'Data płatności od'"
            ></datepicker>
            <datepicker
              :language="pl"
              v-model="selectedDateToSubOrders"
              name="dateTo"
              :placeholder="'Data płatności do'"
            ></datepicker>
          </div>
        </div>
        <button
          class="btn btn-sm btn-styles adjust-height mr-4"
          @click="clearDatesSubOrders()"
        >
          Wyczyść daty
        </button>
      </div>
      <button
        class="btn btn-sm btn-styles adjust-height downloadButton"
        style="margin-top: 0px"
        @click="downloadSubscriptionsOrdersReport()"
      >
        Pobierz
      </button>
      <table class="table borderless">
        <thead>
          <tr class="tr-table">
            <th>Usługa</th>
            <th>Data pierwszej płatności</th>
            <th>Data płatności</th>
            <th>Data rozpoczęcia subskrypcji</th>
            <th>Data zakończenia subskrypcji</th>
            <th>Czy jest opłacona na kolejny miesiąc?</th>
            <th>Rodzaj subskrypcji</th>
            <th>Imię</th>
            <th>Nazwisko</th>
            <th>PESEL</th>
            <th>Płeć</th>
            <th>Data urodzenia</th>
            <th>Numer telefonu</th>
            <th>Email</th>
            <th>Miasto</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(sub, index) in subscriptionOrdersReport"
            :key="`${sub.phone}_${index}`"
            :class="sub.renewed === 'Nie' ? 'not-renewed' : ''"
          >
            <td>{{ sub.service }}</td>
            <td>{{ formattedDate(sub.firstPaymentDate) }}</td>
            <td>{{ formattedDate(sub.paymentDate) }}</td>
            <td>{{ formattedDate(sub.subscriptionStart) }}</td>
            <td>{{ formattedDate(sub.subscriptionFullEnd) }}</td>
            <td>
              {{ sub.renewed }}
            </td>
            <td>{{ sub.subscriptionType }}</td>
            <td>{{ sub.firstName }}</td>
            <td>{{ sub.lastName }}</td>
            <td>{{ sub.pesel }}</td>
            <td>{{ sub.gender }}</td>
            <td>{{ sub.birthdate }}</td>
            <td>{{ sub.phone }}</td>
            <td>{{ sub.email }}</td>
            <td>{{ sub.city }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="reportTable" v-if="userRegulations">
      <button
        class="btn btn-sm btn-styles adjust-height downloadButton"
        @click="
          downloadStandardReport(
            `api/admin/userRegulations/file`,
            'regulations.xls'
          )
        "
      >
        Pobierz
      </button>

      <pagination-inline
        :dispatchAction="`fetchUserRegulationsReport`"
        :onPage="
          this.userRegulationsReport ? this.userRegulationsReport.on_page : 20
        "
        :pageNumber="
          this.userRegulationsReport
            ? this.userRegulationsReport.page_number
            : 1
        "
        :total="this.userRegulationsReport.total"
      ></pagination-inline>

      <table class="table borderless">
        <thead>
          <tr class="tr-table">
            <th>Data</th>
            <th>Id użytkownika</th>
            <th>Tekst checkboxa</th>
            <th>Akcja</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="regulation in userRegulationsReport.list"
            :key="regulation.id"
          >
            <td>{{ regulation.creation_date }}</td>
            <td>{{ regulation.user_id }}</td>
            <td v-html="regulation.type"></td>
            <td>{{ regulation.action }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="reportTable" v-if="serviceRegulations">
      <button
        class="btn btn-sm btn-styles adjust-height downloadButton"
        @click="
          downloadStandardReport(
            `api/admin/userServicesRegulations/file`,
            'services_regulations.xls'
          )
        "
      >
        Pobierz
      </button>
      <pagination-inline
        :dispatchAction="`fetchServiceRegulationsReport`"
        :onPage="
          this.serviceRegulationsReport
            ? this.serviceRegulationsReport.on_page
            : 20
        "
        :pageNumber="
          this.serviceRegulationsReport
            ? this.serviceRegulationsReport.page_number
            : 1
        "
        :total="this.serviceRegulationsReport.total"
      ></pagination-inline>
      <table class="table borderless">
        <thead>
          <tr class="tr-table">
            <th>Data</th>
            <th>Id użytkownika</th>
            <th>Tekst checkboxa</th>
            <th>Akcja</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="regulation in serviceRegulationsReport.list"
            :key="regulation.id"
          >
            <td>{{ regulation.creation_date }}</td>
            <td>{{ regulation.user_id }}</td>
            <td v-html="regulation.type"></td>
            <td>{{ regulation.action }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="reportTable" v-if="usersActivity">
      <table class="table borderless">
        <thead>
          <tr class="tr-table">
            <th style="width: 13%">Okres</th>
            <th>Aktywni w tym okresie</th>
            <th>Nieaktywni w tym okresie</th>
            <th>Zweryfikowani opiekunowie aktywni w tym okresie</th>
            <th>Zweryfikowani opiekunowie nieaktywni w tym okresie</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="report in usersActivityReport" :key="report.id">
            <td>
              {{ formattedDateForActivityReport(report.month) }} -
              {{ formattedDateForActivityReport(report.monthEnd) }}
            </td>
            <td>
              {{ report.numberOfMonthActivity }}
              <p
                style="cursor: pointer; text-decoration: underline"
                @click="
                  downloadUsersActivityReport(
                    report.monthEnd,
                    report.month,
                    false,
                    true
                  )
                "
              >
                Pobierz
              </p>
            </td>
            <td>
              {{ report.notActiveThisMonth }}
              <p
                style="cursor: pointer; text-decoration: underline"
                @click="
                  downloadUsersActivityReport(
                    report.monthEnd,
                    report.month,
                    false,
                    false
                  )
                "
              >
                Pobierz
              </p>
            </td>
            <td>
              {{ report.numberOfMonthVerifiedActivity }}
              <p
                style="cursor: pointer; text-decoration: underline"
                @click="
                  downloadUsersActivityReport(
                    report.monthEnd,
                    report.month,
                    true,
                    true
                  )
                "
              >
                Pobierz
              </p>
            </td>
            <td>
              {{ report.notActiveThisMonthVerified }}
              <p
                style="cursor: pointer; text-decoration: underline"
                @click="
                  downloadUsersActivityReport(
                    report.monthEnd,
                    report.month,
                    true,
                    false
                  )
                "
              >
                Pobierz
              </p>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="reportTable" v-if="adminPermissionSettings">
      <button
        class="btn btn-outline-dark downloadButton"
        @click="
          downloadStandardReport(
            `api/admin/permissionSettings/file`,
            'admin_permissions.xls'
          )
        "
      >
        Pobierz
      </button>

      <table class="table borderless">
        <thead>
          <tr class="tr-table">
            <th>Data</th>
            <th>Autor zmiany</th>
            <th>Edytowany użytkownik</th>
            <th>Poprzednia rola</th>
            <th>Nowa rola</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="report in adminPermissionSettingsReport" :key="report.id">
            <td>{{ formattedDateWithTime(report.creation_date) }}</td>
            <td>{{ report.author_user_login }}</td>
            <td>{{ report.user_login }}</td>
            <td>{{ report.last_admin_role }}</td>
            <td>{{ report.new_admin_role }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="reportTable" v-if="recharges">
      <button
        class="btn btn-outline-dark downloadButton"
        @click="
          downloadStandardReport(
            `/api/admin/rechargeReport/file`,
            'doladowania.xls'
          )
        "
      >
        Pobierz
      </button>

      <table class="table borderless">
        <thead>
          <tr class="tr-table">
            <th>Data</th>
            <th>Typ</th>
            <th>Autor</th>
            <th>Użytkownik</th>
            <th>Kwota</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="report in rechargesReport" :key="report.id">
            <td>{{ formattedDateWithTime(report.creation_date) }}</td>
            <td>{{ rechargeName(report.recharge_type) }}</td>
            <td>{{ report.author_user }}</td>
            <td>{{ report.user }}</td>
            <td>{{ report.amount }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="reportTable" v-if="walletBalances">
      <button
        class="btn btn-outline-dark downloadButton"
        @click="
          downloadStandardReport(
            `/api/admin/walletBalancesReport/file`,
            'srodki_w_portfelu.xls'
          )
        "
      >
        Pobierz
      </button>

      <table class="table borderless">
        <thead>
          <tr class="tr-table">
            <th>L.p.</th>
            <th>Imię i nazwisko</th>
            <th>Numer telefonu</th>
            <th>Suma środków w portfelu</th>
            <th>Ostatnio zamówiona usługa</th>
            <th>Data ostatniego zamówienia</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(report, index) in walletBalancesReport"
            :key="`${report.phone}_${index}`"
          >
            <td>{{ index + 1 }}</td>
            <td>{{ report.first_name }} {{ report.last_name }}</td>
            <td>{{ report.phone }}</td>
            <td>{{ report.amount }}</td>
            <td>{{ report.last_service_name }}</td>
            <td>
              {{
                report.last_order_date
                  ? formattedDate(report.last_order_date)
                  : "-"
              }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="reportTable" v-if="triedToLoginReport">
      <button
        class="btn btn-outline-dark downloadButton"
        @click="
          downloadStandardReport(
            `api/admin/triedToLogIn/file`,
            'users_failed_login.xls'
          )
        "
      >
        Pobierz
      </button>

      <table class="table borderless">
        <thead>
          <tr class="tr-table">
            <th>ID użytkownika</th>
            <th>Data utworzenia</th>
            <th>Imię</th>
            <th>Nazwisko</th>
            <th>Telefon</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="data in this.usersWhoTriedToLogIn.user_profile_service"
            :key="data.user_profile.user.id"
          >
            <td>{{ data.user_profile.user.id }}</td>
            <td>{{ data.user_profile.user.creation_date }}</td>

            <td>{{ data.user_profile.profile.first_name }}</td>
            <td>{{ data.user_profile.profile.last_name }}</td>
            <td>{{ data.user_profile.user.phone }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="reportTable" v-if="languagesReport">
      <button
        class="btn btn-outline-dark downloadButton"
        @click="
          downloadStandardReport(
            `api/admin/profileElementsReport/file?type=LANGUAGES`,
            'profile_languages.xls'
          )
        "
      >
        Pobierz
      </button>

      <table class="table borderless">
        <thead>
          <tr class="tr-table">
            <th>Język</th>
            <th>Ilośc</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="language in this.languagesReportList" :key="language.name">
            <td>{{ language.name }}</td>
            <td>{{ language.counter }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="reportTable" v-if="profileFeaturesReport">
      <button
        class="btn btn-outline-dark downloadButton"
        @click="
          downloadStandardReport(
            `api/admin/profileElementsReport/file?type=PROFILE_FEATURE`,
            'more_about_users.xls'
          )
        "
      >
        Pobierz
      </button>

      <table class="table borderless">
        <thead>
          <tr class="tr-table">
            <th>Nazwa</th>
            <th>Ilośc</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="profileFeature in this.profileFeaturesReportList"
            :key="profileFeature.name"
          >
            <td>{{ profileFeature.name }}</td>
            <td>{{ profileFeature.counter }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="reportTable" v-if="healthDataConsentsReport">
      <button
        class="btn btn-outline-dark downloadButton"
        @click="
          downloadStandardReport(
            `api/admin/healthDataConsentsReport/file`,
            'health_data_consents.xls'
          )
        "
      >
        Pobierz
      </button>

      <table class="table borderless">
        <thead>
          <tr class="tr-table">
            <th>Użytkownik</th>
            <th>Numer telefonu</th>
            <th>Status zgody</th>
            <th>Data</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="row in healthDataConsentsReportList" :key="row.user_id">
            <td>
              {{ [row.first_name, row.last_name].filter(Boolean).join(" ") }}
            </td>
            <td>{{ row.phone }}</td>
            <td>{{ row.status === "ACCEPTED" ? "Udzielona" : "Wycofana" }}</td>
            <td>{{ formatWarsawDateTime(row.date) }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="reportTable" v-if="trainingsReport">
      <button
        class="btn btn-outline-dark downloadButton"
        @click="
          downloadStandardReport(
            `api/admin/profileElementsReport/file?type=TRAINING`,
            'profile_trainings.xls'
          )
        "
      >
        Pobierz
      </button>

      <table class="table borderless">
        <thead>
          <tr class="tr-table">
            <th>Nazwa</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="training in this.trainingsReportList" :key="training">
            <td>{{ training }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="reportTable" v-if="cvsReport">
      <div class="d-flex">
        <search-input
          placeholder="Miasto"
          @search="handleCvsReportCitySearchInput"
        />
        <search-input
          placeholder="Kategoria usługi"
          @search="handleCvsReportServiceCategorySearchInput"
        />
        <search-input
          placeholder="Podkategoria usługi"
          @search="handleCvsReportServiceSubcategorySearchInput"
        />
        <search-input
          placeholder="Usługa"
          @search="handleCvsReportServiceSearchInput"
        />
      </div>

      <button
        class="btn btn-outline-dark downloadButton"
        @click="
          downloadStandardReport(
            `api/admin/profileElementsReport/file?type=CV`,
            'users_cv.xls',
            {
              service_category_display_name:
                cvsReportServiceCategorySearchValue,
              subcategory_display_name: cvsReportServiceSubcategorySearchValue,
              service_display_name: cvsReportServiceSearchValue,
              city: cvsReportCitySearchValue,
            }
          )
        "
      >
        Pobierz
      </button>

      <table class="table borderless">
        <thead>
          <tr class="tr-table">
            <th>Id użytkownika</th>
            <th>Imię</th>
            <th>Nazwisko</th>
            <th>Miasto</th>
            <th>Numer telefonu</th>
            <th>Pobierz CV</th>
            <th>Podgląd profilu</th>
            <th>Status weryfikacji opiekuna</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in this.cvsReportList" :key="item.cv_id">
            <td>{{ item.user_id }}</td>
            <td>{{ item.user_first_name }}</td>
            <td>{{ item.user_last_name }}</td>
            <td>{{ item.user_city || item.second_city || "Brak" }}</td>
            <td>{{ item.user_phone }}</td>
            <td>
              <button
                class="btn btn-sm btn-outline-dark"
                @click="downloadEmployeeCv(item.cv_id.split('.')[0])"
              >
                Pobierz
              </button>
            </td>
            <td>
              <router-link :to="{ path: '/users/id/' + item.user_id }">
                <button type="button" class="btn btn-outline-dark mr-3">
                  Przejdź
                </button>
              </router-link>
            </td>
            <td>{{ item.user_employee_status }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="reportTable" v-if="smsReport">
      <button
        class="btn btn-outline-dark downloadButton"
        @click="downloadStandardReport(`api/admin/smses/file`, 'sms.xls')"
      >
        Pobierz
      </button>

      <table class="table borderless">
        <thead>
          <tr class="tr-table">
            <th>Miesiąc</th>
            <th>Liczba wysłanych smsów</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="smsReport in this.smsReportList" :key="smsReport.id">
            <td>{{ smsReport.year }}/{{ smsReport.month }}</td>
            <td>{{ smsReport.counter }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="reportTable" v-if="usersAndOrdersReport">
      <button
        class="btn btn-sm btn-outline-dark downloadButton"
        @click="
          downloadStandardReport(
            `/api/admin/usersAndOrders/file`,
            `usersAndOrders.xls`
          )
        "
      >
        Pobierz
      </button>
      <table class="table borderless">
        <thead>
          <tr class="tr-table">
            <th>Miesiąc</th>
            <th>Wszyscy użytkownicy</th>
            <th>Zweryfikowani użytkownicy</th>
            <th>Zamówienia</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in usersAndOrdersList" :key="item.id">
            <td>{{ item.date }}</td>
            <td class="row-with-button">
              <div class="mr-4">{{ item.allUsersCounter }}</div>

              <button
                type="button"
                class="btn btn-outline-dark mr-3"
                data-toggle="modal"
                data-target="#usersAndOrdersReportDaily"
                @click="
                  setUsersAndOrdersDailyReport(item.allUsersDailyCounters)
                "
              >
                Dzienny raport
              </button>
            </td>
            <td class="row-with-button">
              <div class="mr-4">{{ item.verifiedUsersCounter }}</div>
              <button
                type="button"
                class="btn btn-outline-dark mr-3"
                data-toggle="modal"
                data-target="#usersAndOrdersReportDaily"
                @click="
                  setUsersAndOrdersDailyReport(item.verifiedUsersDailyCounters)
                "
              >
                Dzienny raport
              </button>
            </td>
            <td class="row-with-button">
              <div class="mr-4">{{ item.ordersCounter }}</div>
              <button
                type="button"
                class="btn btn-outline-dark mr-3"
                data-toggle="modal"
                data-target="#usersAndOrdersReportDaily"
                @click="setUsersAndOrdersDailyReport(item.ordersDailyCounters)"
              >
                Dzienny raport
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="reportTable" v-if="ordersByStatusReport">
      <button
        class="btn btn-sm btn-outline-dark downloadButton"
        @click="
          downloadStandardReport(`/api/admin/ordersByStatus/file`, `orders.xls`)
        "
      >
        Pobierz
      </button>

      <table class="table borderless">
        <thead>
          <tr class="tr-table">
            <th></th>
            <th>ACCEPTED</th>
            <th>CANCELLED_CUSTOMER</th>
            <th>CANCELLED_EMPLOYEE</th>
            <th>FINISHED</th>
            <th>INITIALIZED</th>
            <th>REJECTED</th>
            <th>UNREALIZED</th>
            <th>WAITING</th>
            <th>Suma końcowa</th>
          </tr>
        </thead>
        <tbody>
          <tr
            :class="
              index === ordersByStatusList.length - 1
                ? 'orders-by-status-year-row'
                : ''
            "
            :style="isNumeric(item.label) ? 'font-weight: bold;' : ''"
            v-for="(item, index) in ordersByStatusList"
            :key="item.id"
          >
            <td>
              {{ item.label }}
            </td>
            <td class="orders-by-status-yellow-row">
              {{ item.acceptedOrdersCounter }}
            </td>
            <td>{{ item.cancelledCustomerOrdersCounter }}</td>
            <td>{{ item.cancelledEmployeeOrdersCounter }}</td>
            <td class="orders-by-status-yellow-row">
              {{ item.finishedOrdersCounter }}
            </td>
            <td>{{ item.initializedOrdersCounter }}</td>
            <td>{{ item.rejectedOrdersCounter }}</td>
            <td>{{ item.unrealizedOrdersCounter }}</td>
            <td>{{ item.waitingOrdersCounter }}</td>
            <td>{{ item.sumOrdersCounter }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="reportTable" v-if="usersServicesByCityReport">
      <div class="d-flex">
        <search-input
          placeholder="Miasto"
          @search="handleUserServicesByCityCitySearchInput"
          defaultValue="Łódź"
        />
        <search-input
          placeholder="Kategoria"
          @search="handleUserServicesByCityServiceCategorySearchInput"
        />
        <search-input
          placeholder="Podkategoria"
          @search="handleUserServicesByCityServiceSubcategorySearchInput"
        />
        <search-input
          placeholder="Usługa"
          @search="handleUserServicesByCityServiceSearchInput"
        />
      </div>
      <h4 class="ml-4" v-if="usersServicesByCityList">
        Liczba opiekunów zweryfikowanych łącznie:
        {{
          usersServicesByCityList.reduce((sum, object) => {
            return sum + object.counter;
          }, 0)
        }}
      </h4>
      <button
        class="btn btn-sm btn-outline-dark downloadButton"
        @click="
          downloadStandardReport(
            `/api/admin/verifiedUsersByCity/file`,
            `verified_users_services.xls`,
            {
              service_category_display_name:
                usersServicesByCityReportServiceCategorySearchValue,
              service_subcategory_display_name:
                usersServicesByCityReportServiceSubcategorySearchValue,
              service_display_name: usersServicesByCityReportServiceSearchValue,
              city: usersServicesByCityReportCitySearchValue,
            }
          )
        "
      >
        Pobierz
      </button>
      <table class="table borderless">
        <thead>
          <tr class="tr-table">
            <th>Miasto</th>
            <th>Kategoria</th>
            <th>Podkategoria</th>
            <th>Usługa</th>
            <th>Liczba opiekunów zweryfikowanych</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(item, index) in usersServicesByCityList"
            :key="`${item.service_name}_${index}`"
          >
            <td>{{ item.city }}</td>
            <td>{{ item.category_name }}</td>
            <td>{{ item.subcategory_name || "Brak" }}</td>
            <td>{{ item.service_name }}</td>
            <td class="usersServicesByCityListCounter">
              <i
                class="fas fa-info-circle mr-4"
                data-toggle="modal"
                data-target="#usersServicesByCityReportDetails"
                @click="showUsersServicesByCityDetails(item)"
              >
              </i>
              <span>
                {{ item.counter }}
              </span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="reportTable" v-if="dodBillsReport">
      <div class="datepickers dodBillsDatepicker">
        <datepicker
          :monday-first="true"
          :language="pl"
          :minimum-view="'month'"
          :maximum-view="'year'"
          :initial-view="'month'"
          :format="'yyyy-MM'"
          v-model="dodBillsSelectedDate"
          name="dodBillsDate"
          :placeholder="'Miesiąc i rok'"
        ></datepicker>
      </div>
      <button
        class="btn btn-sm btn-outline-dark downloadButton"
        @click="
          downloadStandardReport(
            `/api/admin/dodBillsReport/file`,
            `dod_bills_${dodBillsYear}_${dodBillsMonth}.xls`,
            { year: dodBillsYear, month: dodBillsMonth }
          )
        "
      >
        Pobierz
      </button>
      <table class="table borderless">
        <thead>
          <tr class="tr-table">
            <th>Nazwisko imię</th>
            <th>Rachunek</th>
            <th>Brutto do wypłaty</th>
            <th>Data wystawienia</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(item, index) in dodBillsReportList"
            :key="`${item.billNumber}_${index}`"
          >
            <td>{{ item.employeeName }}</td>
            <td>{{ item.billNumber }}</td>
            <td>{{ item.price != null ? item.price.toFixed(2) : "" }} zł</td>
            <td>{{ item.issueDate }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="reportTable" v-if="invoicesReport">
      <div class="datepickers dodBillsDatepicker">
        <datepicker
          :monday-first="true"
          :language="pl"
          :minimum-view="'month'"
          :maximum-view="'year'"
          :initial-view="'month'"
          :format="'yyyy-MM'"
          v-model="invoicesSelectedDate"
          name="invoicesDate"
          :placeholder="'Miesiąc i rok'"
        ></datepicker>
      </div>
      <button
        class="btn btn-sm btn-outline-dark downloadButton"
        @click="
          downloadStandardReport(
            `/api/admin/invoicesReport/file`,
            `faktury_${invoicesYear}_${invoicesMonth}.xls`,
            { year: invoicesYear, month: invoicesMonth }
          )
        "
      >
        Pobierz
      </button>
      <div class="invoicesSummary">
        <span class="summaryItem">
          Razem: <b>{{ invoicesSummary.total }}</b>
          ({{ invoicesSummary.sumBrutto }} zł)
        </span>
        <span class="summaryItem invoiceStatus invoiceStatus--sent">
          PRZESŁANO: {{ invoicesSummary.sent }}
        </span>
        <span class="summaryItem invoiceStatus invoiceStatus--unsent">
          NIEPRZESŁANA: {{ invoicesSummary.unsent }}
        </span>
        <span class="summaryItem invoiceStatus invoiceStatus--missing">
          NIEWYSTAWIONA: {{ invoicesSummary.missing }}
        </span>
      </div>
      <table class="table borderless">
        <thead>
          <tr class="tr-table">
            <th>ID</th>
            <th>Nazwa</th>
            <th>Usługa</th>
            <th>Data</th>
            <th>Wystawca</th>
            <th>Odbiorca</th>
            <th>Kwota BRUTTO</th>
            <th>Status</th>
            <th>Link</th>
            <th>Uwagi</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(item, index) in invoicesReportList"
            :key="`${item.orderId}_${index}`"
          >
            <td>
              <div class="id-column" :title="item.orderId">
                <img
                  @click="copyText(item.orderId)"
                  style="cursor: pointer"
                  src="@/icons/copy-icons.svg"
                  alt="Kopiuj ID zamówienia"
                />
              </div>
            </td>
            <td>{{ item.invoiceNumber || "—" }}</td>
            <td>{{ item.serviceName }}</td>
            <td>{{ item.date }}</td>
            <td>{{ item.issuer }}</td>
            <td>{{ item.recipient }}</td>
            <td>
              {{ item.grossAmount != null ? item.grossAmount.toFixed(2) : "" }}
              zł
            </td>
            <td>
              <span class="invoiceStatus" :class="statusClass(item.status)">
                {{ item.statusLabel }}
              </span>
            </td>
            <td>
              <a
                v-if="item.pdfUrl"
                :href="item.pdfUrl"
                target="_blank"
                rel="noopener"
                class="btn btn-sm btn-outline-dark"
              >
                PDF
              </a>
              <span v-else>-</span>
            </td>
            <td>{{ item.note }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="reportTable" v-if="usersReportsFromAppReport">
      <button
        class="btn btn-sm btn-outline-dark downloadButton"
        @click="
          downloadStandardReport(
            `/api/admin/usersReports/file`,
            `usersReportsFromApp.xls`
          )
        "
      >
        Pobierz
      </button>
      <table class="table borderless">
        <thead>
          <tr class="tr-table">
            <th>Data</th>
            <th>Id zgłoszonego użytkownika</th>
            <th>Id zgłaszającego użytkownika</th>
            <th>Kategoria</th>
            <th>Szczegóły</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(item, index) in usersReportsFromAppList"
            :key="`${item.userId}_${index}`"
          >
            <td>{{ formattedDateWithTime(item.creationDate) }}</td>
            <td>
              {{ item.userId }}
            </td>
            <td>{{ item.reportingUserId }}</td>
            <td>{{ item.category || "Brak" }}</td>
            <td>{{ item.description || "Brak" }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div
      class="modal fade"
      id="usersAndOrdersReportDaily"
      tabindex="-1"
      role="dialog"
      aria-labelledby="usersAndOrdersReportDaily"
      aria-hidden="true"
    >
      <div
        class="modal-dialog modal-xl modal-dialog modal-xl-scrollable"
        role="document"
      >
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">Raport dzienny</h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body messagesBody">
            <table class="table borderless">
              <thead>
                <tr>
                  <td>Dzień</td>
                  <td>Liczba</td>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(counter, index) in usersAndOrdersReportDaily"
                  :key="index + counter + 'usersAndOrdersDaily'"
                >
                  <td>{{ counter.date }}</td>
                  <td>{{ counter.counter }}</td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-outline-dark"
              data-dismiss="modal"
            >
              Zamknij
            </button>
          </div>
        </div>
      </div>
    </div>

    <div
      class="modal fade"
      id="usersServicesByCityReportDetails"
      tabindex="-1"
      role="dialog"
      aria-labelledby="usersServicesByCityReportDetails"
      aria-hidden="true"
    >
      <div
        class="modal-dialog modal-xl modal-dialog modal-xl-scrollable"
        role="document"
      >
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">
              Numery telefonów opiekunów z wybraną usługą
            </h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body messagesBody">
            {{ usersServicesByCityReportDetails.join(" ") }}
          </div>

          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-outline-dark"
              data-dismiss="modal"
            >
              Zamknij
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Datepicker from "vuejs-datepicker";
import { pl } from "vuejs-datepicker/dist/locale";
import axios from "../../axios";
import PaginationInline from "../../components/PaginationInline.vue";
import SubscriptionsReportsView from "../../components/reports/SubscriptionsReportsView.vue";
import SearchInput from "../../components/SearchInput.vue";
import shared from "../../shared";
export default {
  name: "Reports",
  components: {
    Datepicker,
    PaginationInline,
    SearchInput,
    SubscriptionsReportsView,
  },
  data() {
    return {
      pl: pl,
      frozenMoney: 0,
      waitingWithdraws: 0,
      returnedDiscounts: 0,
      reportData: [],
      columns: [],
      reportTypes: [],
      selectedType: "",
      dailyUsers: [],
      dailyReportMonth: null,
      dailyUsersReportArray: [],
      servicesWithUserPhoneNumbersService: null,
      servicesWithUserPhoneNumbersList: [],
      servicesWithUserPhoneNumbers: null,
      phoneNumbers: [],
      selectedRow: null,
      userServicesInSpecifiedCitiesReport: false,
      promotionalCodesReport: false,
      referralCodesReport: false,
      usersAndUserServicesReport: false,
      toggleOnlyUsedPromotionalCodes: false,
      ordersRejectionReport: false,
      userSubscriptions: false,
      userSubscriptionsOrders: false,
      onlyAutoOrdersRejection: false,
      onlyUserOrdersRejection: false,
      selectedDateFrom: null,
      selectedDateTo: null,
      selectedDateFromSubOrders: null,
      selectedDateToSubOrders: null,
      filterType: "",
      filterSubOrdersType: "",
      loadingPhoneNumbers: false,
      userRegulations: false,
      serviceRegulations: false,
      usersActivity: false,
      adminPermissionSettings: false,
      recharges: false,
      walletBalances: false,
      triedToLoginReport: false,
      languagesReport: false,
      trainingsReport: false,
      profileFeaturesReport: false,
      healthDataConsentsReport: false,
      healthDataConsentsReportList: [],
      cvsReport: false,
      smsReport: false,
      usersAndOrdersReport: false,
      ordersByStatusReport: false,
      usersAndOrdersReportDaily: [],
      usersServicesByCityReport: false,
      usersServicesByCityReportServiceCategorySearchValue: "",
      usersServicesByCityReportServiceSubcategorySearchValue: "",
      usersServicesByCityReportServiceSearchValue: "",
      usersServicesByCityReportCitySearchValue: "Łódź",
      usersServicesByCityReportDetails: [],
      cvsReportServiceCategorySearchValue: "",
      cvsReportServiceSubcategorySearchValue: "",
      cvsReportServiceSearchValue: "",
      cvsReportCitySearchValue: "",
      usersReportsFromAppReport: false,
      dodBillsReport: false,
      dodBillsSelectedDate: new Date(new Date().getFullYear(), new Date().getMonth(), 1),
      invoicesReport: false,
      invoicesSelectedDate: new Date(new Date().getFullYear(), new Date().getMonth(), 1),
      invoicesVerifying: false,
      invoiceLink: "",
      invoicesGroupedByUser: [],
      showedMoreSubscriptionOrders: [],
      addedMainRow: {},
    };
  },
  created() {
    this.getReportTypes();
    this.resetAllReports();
    this.formattedDate = shared.formattedDateWithoutTime;
    this.formattedDateForActivityReport =
      shared.formattedDateWithoutTimeToString;
    this.formattedDateWithTime = shared.formattedDateToStringWithTime;
    this.formattedDateWithTime = shared.formattedDateAsNumbers;
    this.rechargeName = shared.getRechargeName;
  },
  async mounted() {
    const body = {
      date_from: "2021-01-01",
      date_to: "2930-01-01",
      type: null,
    };
    await this.$store.dispatch("fetchSubsFilteringParams");
    // The subscriptions report is fetched by <subscriptions-reports-view> itself; a parallel call
    // from here would cancel its filtered request (only the newest one is kept).
    await this.$store.dispatch("fetchSubscriptionsOrdersReport", body);
  },
  watch: {
    selectedDateFrom() {
      if (this.selectedDateFrom) {
        this.fetchUserSubscriptions();
      }
    },
    selectedDateTo() {
      if (this.selectedDateTo) {
        this.fetchUserSubscriptions();
      }
    },
    selectedDateFromSubOrders() {
      if (this.selectedDateFromSubOrders) {
        this.fetchUserSubscriptionsOrders();
      }
    },
    selectedDateToSubOrders() {
      if (this.selectedDateToSubOrders) {
        this.fetchUserSubscriptionsOrders();
      }
    },
    dodBillsSelectedDate() {
      if (this.dodBillsReport) {
        this.fetchDodBillsReport();
      }
    },
    invoicesSelectedDate() {
      if (this.invoicesReport) {
        this.fetchInvoicesReport();
      }
    },
    toggleOnlyUsedPromotionalCodes() {
      this.$store.dispatch("fetchPromotionalCodesReport", {
        only_used: this.toggleOnlyUsedPromotionalCodes,
      });
    },

    paymentTypesAmountsReport() {
      if (this.paymentTypesAmountsReport && this.paymentTypesAmountsReport[0]) {
        const additionalData =
          this.paymentTypesAmountsReport[0].additional_data_list[0];
        this.frozenMoney = parseFloat(additionalData.FROZEN_MONEY);
        this.waitingWithdraws = parseFloat(additionalData.WAITING_WITHDRAWS);
        this.returnedDiscounts = parseFloat(additionalData.RETURNED_DISCOUNTS);
      }
    },
  },
  methods: {
    showMoreSubscriptionsOrders(orderId) {
      if (!this.showedMoreSubscriptionOrders.includes(orderId)) {
        this.showedMoreSubscriptionOrders.push(orderId);
      }
    },

    hideMoreSubscriptionsOrders(orderId) {
      this.showedMoreSubscriptionOrders =
        this.showedMoreSubscriptionOrders.filter((o) => o !== orderId);
    },

    async fetchInvoiceLink(id) {
      this.invoiceLink = null;
      await axios
        .get(`/api/payment/invoice/subscription/${id}`)
        .then((response) => {
          this.invoiceLink = response.data;
        });

      document.getElementById(`downloadLink${id}`).click();
    },

    async copyInvoiceLinkToClipboard(id) {
      let link = "";
      await axios
        .get(`/api/payment/invoice/subscription/${id}`)
        .then((response) => {
          link = response.data;
        });
      const el = document.createElement("textarea");
      el.value = link;
      el.setAttribute("readonly", "");
      el.style.position = "absolute";
      el.style.left = "-9999px";
      document.body.appendChild(el);
      el.select();
      document.execCommand("copy");
      document.body.removeChild(el);
      this.$notify({
        group: "success",
        text: "Link do faktury został skopiowany",
      });
    },

    downloadEmployeeCv(cvId) {
      let url = `api/admin/cv-download/${cvId}`;

      axios(url, {
        method: "GET",
        headers: {
          "Content-Disposition": "attachment; filename=reports.xls",
          "Content-Type":
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        },
        responseType: "blob",
      })
        .then((response) => {
          const fileURL = window.URL.createObjectURL(new Blob([response.data]));
          const fileLink = document.createElement("a");

          fileLink.href = fileURL;
          fileLink.setAttribute("download", cvId + "_cv.pdf");
          document.body.appendChild(fileLink);
          fileLink.click();
        })
        .catch((err) => console.log(err.response));
    },

    async showUsersServicesByCityDetails(usersServicesItem) {
      this.usersServicesByCityReportDetails = [];
      const { category_name, city, service_name, subcategory_name } =
        usersServicesItem;
      const response = await axios.get(
        "/api/admin/verifiedUsersByCity/usersPhones",
        {
          params: {
            service_category_display_name: category_name,
            service_display_name: service_name,
            subcategory_display_name: subcategory_name,
            city,
          },
        }
      );
      this.usersServicesByCityReportDetails = response.data;
    },
    handleUserServicesByCityCitySearchInput(searchValue) {
      this.usersServicesByCityReportCitySearchValue = searchValue;
      this.showUsersServicesByCityReport(
        this.usersServicesByCityReportServiceCategorySearchValue,
        this.usersServicesByCityReportServiceSubcategorySearchValue,
        this.usersServicesByCityReportServiceSearchValue,
        this.usersServicesByCityReportCitySearchValue
      );
    },

    handleUserServicesByCityServiceCategorySearchInput(searchValue) {
      this.usersServicesByCityReportServiceCategorySearchValue = searchValue;
      this.showUsersServicesByCityReport(
        this.usersServicesByCityReportServiceCategorySearchValue,
        this.usersServicesByCityReportServiceSubcategorySearchValue,
        this.usersServicesByCityReportServiceSearchValue,
        this.usersServicesByCityReportCitySearchValue
      );
    },
    handleUserServicesByCityServiceSubcategorySearchInput(searchValue) {
      this.usersServicesByCityReportServiceSubcategorySearchValue = searchValue;
      this.showUsersServicesByCityReport(
        this.usersServicesByCityReportServiceCategorySearchValue,
        this.usersServicesByCityReportServiceSubcategorySearchValue,
        this.usersServicesByCityReportServiceSearchValue,
        this.usersServicesByCityReportCitySearchValue
      );
    },
    handleUserServicesByCityServiceSearchInput(searchValue) {
      this.usersServicesByCityReportServiceSearchValue = searchValue;
      this.showUsersServicesByCityReport(
        this.usersServicesByCityReportServiceCategorySearchValue,
        this.usersServicesByCityReportServiceSubcategorySearchValue,
        this.usersServicesByCityReportServiceSearchValue,
        this.usersServicesByCityReportCitySearchValue
      );
    },

    handleCvsReportCitySearchInput(searchValue) {
      this.cvsReportCitySearchValue = searchValue;
      this.showProfileElementsReport("CVS", true);
    },

    handleCvsReportServiceCategorySearchInput(searchValue) {
      this.cvsReportServiceCategorySearchValue = searchValue;
      this.showProfileElementsReport("CVS", true);
    },
    handleCvsReportServiceSubcategorySearchInput(searchValue) {
      this.cvsReportServiceSubcategorySearchValue = searchValue;
      this.showProfileElementsReport("CVS", true);
    },
    handleCvsReportServiceSearchInput(searchValue) {
      this.cvsReportServiceSearchValue = searchValue;
      this.showProfileElementsReport("CVS", true);
    },

    isNumeric(str) {
      if (typeof str != "string") return false;
      return !isNaN(str) && !isNaN(parseFloat(str));
    },
    setUsersAndOrdersDailyReport(report) {
      this.usersAndOrdersReportDaily = report;
    },
    async clearDates() {
      this.selectedDateFrom = null;
      this.selectedDateTo = null;
      const body = {
        date_from: "2021-01-01",
        date_to: "2930-01-01",
        type: this.filterType ? this.filterType : null,
      };
      await this.$store.dispatch("fetchSubscriptionsReport", body);
    },
    async clearDatesSubOrders() {
      this.selectedDateFromSubOrders = null;
      this.selectedDateToSubOrders = null;
      const body = {
        date_from: "2021-01-01",
        date_to: "2930-01-01",
        type: this.filterSubOrdersType ? this.filterSubOrdersType : null,
      };
      await this.$store.dispatch("fetchSubscriptionsOrdersReport", body);
    },

    async handleOrdersRejectionFilter(e) {
      const filter = e.target.value;
      if (filter === "all") {
        this.onlyAutoOrdersRejection = false;
        this.onlyUserOrdersRejection = false;
        this.showOrdersRejectionReport();
      }
      if (filter === "auto_rejected") {
        this.onlyAutoOrdersRejection = true;
        this.onlyUserOrdersRejection = false;
        this.showOrdersRejectionReport();
      }
      if (filter === "user_rejected") {
        this.onlyAutoOrdersRejection = false;
        this.onlyUserOrdersRejection = true;
        this.showOrdersRejectionReport();
      }
    },
    async fetchUserSubscriptions() {
      const body = {
        date_from: this.selectedDateFrom
          ? this.selectedDateFrom.toISOString().split("T")[0]
          : "2021-01-01",
        date_to: this.selectedDateTo
          ? this.selectedDateTo.toISOString().split("T")[0]
          : "2030-01-01",
        type: this.filterType ? this.filterType : null,
      };
      await this.$store.dispatch("fetchSubscriptionsReport", body);
    },

    async fetchUserSubscriptionsOrders() {
      const body = {
        date_from: this.selectedDateFromSubOrders
          ? this.selectedDateFromSubOrders.toISOString().split("T")[0]
          : "2021-01-01",
        date_to: this.selectedDateToSubOrders
          ? this.selectedDateToSubOrders.toISOString().split("T")[0]
          : "2030-01-01",
        type: this.filterSubOrdersType ? this.filterSubOrdersType : null,
      };
      await this.$store.dispatch("fetchSubscriptionsOrdersReport", body);
    },

    handleSubParamChange(e) {
      this.filterType = e.target.value;
      this.fetchUserSubscriptions();
    },
    handleSubOrdersParamChange(e) {
      this.filterSubOrdersType = e.target.value;
      this.fetchUserSubscriptions();
    },
    handleToggle() {
      this.toggleOnlyUsedPromotionalCodes =
        !this.toggleOnlyUsedPromotionalCodes;
    },

    async downloadStandardReport(url, fileNameWithExtension, params) {
      try {
        const response = await axios(url, {
          method: "GET",
          headers: {
            "Content-Disposition": `attachment; filename=${fileNameWithExtension}`,
            "Content-Type":
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          },
          responseType: "blob",
          params: params || {},
        });

        if (response) {
          const fileURL = window.URL.createObjectURL(new Blob([response.data]));
          const fileLink = document.createElement("a");
          fileLink.href = fileURL;
          fileLink.setAttribute("download", fileNameWithExtension);
          document.body.appendChild(fileLink);
          fileLink.click();
        }
      } catch (error) {
        console.log(error);
      }
    },

    downloadPromotionalCodesReport(code, yearAndMonth) {
      const year = yearAndMonth.split("-")[0];
      const month = yearAndMonth.split("-")[1];
      const url = `api/admin/promotionalCodes/file?code=${code}&year=${year}&month_number=${month}&only_used=${this.toggleOnlyUsedPromotionalCodes}`;
      axios(url, {
        method: "GET",
        headers: {
          "Content-Disposition":
            "attachment; filename=list_of_users_who_used_the_code.xls",
          "Content-Type":
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        },
        responseType: "blob",
      })
        .then((response) => {
          const fileURL = window.URL.createObjectURL(new Blob([response.data]));
          const fileLink = document.createElement("a");

          fileLink.href = fileURL;
          fileLink.setAttribute(
            "download",
            "list_of_users_who_used_the_code.xls"
          );
          document.body.appendChild(fileLink);
          fileLink.click();
        })
        .catch((err) => console.log(err));
    },

    async downloadSubscriptionsReport() {
      const body = {
        date_from: this.selectedDateFrom
          ? this.selectedDateFrom.toISOString().split("T")[0]
          : "2021-01-01",
        date_to: this.selectedDateTo
          ? this.selectedDateTo.toISOString().split("T")[0]
          : "2030-01-01",
        type: this.filterType ? this.filterType : null,
      };

      const url = `/api/admin/userSubscriptions/file`;
      const params = {
        date_from: body.date_from,
        date_to: body.date_to,
      };
      if (body.type) {
        params.type = body.type;
      }

      axios(url, {
        method: "GET",
        headers: {
          "Content-Disposition":
            "attachment; filename=subscriptions_report.xls",
          "Content-Type":
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        },
        responseType: "blob",
      })
        .then((response) => {
          const fileURL = window.URL.createObjectURL(new Blob([response.data]));
          const fileLink = document.createElement("a");

          fileLink.href = fileURL;
          fileLink.setAttribute("download", "subscriptions_report.xls");
          document.body.appendChild(fileLink);
          fileLink.click();
        })
        .catch((err) => console.log(err));
    },

    async downloadSubscriptionsOrdersReport() {
      const body = {
        date_from: this.selectedDateFromSubOrders
          ? this.selectedDateFromSubOrders.toISOString().split("T")[0]
          : "2021-01-01",
        date_to: this.selectedDateToSubOrders
          ? this.selectedDateToSubOrders.toISOString().split("T")[0]
          : "2030-01-01",
        type: this.filterSubOrdersType ? this.filterSubOrdersType : null,
      };

      const url = `/api/admin/userSubscriptionsOrders/file?date_from=${body.date_from}&date_to=${body.date_to}&type=${body.type}`;

      axios(url, {
        method: "GET",
        headers: {
          "Content-Disposition":
            "attachment; filename=subscriptions_report.xls",
          "Content-Type":
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        },
        responseType: "blob",
      })
        .then((response) => {
          const fileURL = window.URL.createObjectURL(new Blob([response.data]));
          const fileLink = document.createElement("a");

          fileLink.href = fileURL;
          fileLink.setAttribute("download", "subscriptions_report.xls");
          document.body.appendChild(fileLink);
          fileLink.click();
        })
        .catch((err) => console.log(err));
    },

    async downloadUsersActivityReport(date, dateStart, onlyVerified, isActive) {
      const url = `/api/admin/userActivity/file?date=${date}&dateStart=${dateStart}&only_verified=${onlyVerified}&is_active=${isActive} `;

      const fileName = dateStart + "_" + date + ".xls";

      axios(url, {
        method: "GET",
        headers: {
          "Content-Disposition": `attachment; filename=${fileName}`,
          "Content-Type":
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        },
        responseType: "blob",
      })
        .then((response) => {
          const fileURL = window.URL.createObjectURL(new Blob([response.data]));
          const fileLink = document.createElement("a");

          fileLink.href = fileURL;
          fileLink.setAttribute("download", fileName);
          document.body.appendChild(fileLink);
          fileLink.click();
        })
        .catch((err) => console.log(err));
    },

    getNumberOfEmployees(city, categoryName) {
      const results = this.userServicesInSpecifiedCities;
      let response = 0;
      results.forEach((result) => {
        if (result.name === categoryName) {
          result.employeesNumberAndCity.forEach((element) => {
            if (element.city === city) {
              response = element.numberOfEmployees;
            }
          });
        }
      });
      return response;
    },

    async getServicesWithUserPhoneNumbersListReport(element, index) {
      this.loadingPhoneNumbers = true;
      try {
        this.phoneNumbers = [];
        this.servicesWithUserPhoneNumbersList = [];
        this.servicesWithUserPhoneNumbersService = null;
        this.servicesWithUserPhoneNumbers = [];

        const row =
          element.srcElement.parentElement.parentElement.parentNode.rowIndex -
          1;
        this.selectedRow = row;
        this.servicesWithUserPhoneNumbers =
          this.reportData[row].services_with_user_phone_numbers;
        const date = (this.servicesWithUserPhoneNumbers =
          this.reportData[row].date);
        this.servicesWithUserPhoneNumbersService = Object.keys(
          this.reportData[0].results
        )[index];

        const service_category_and_service_display_name =
          this.servicesWithUserPhoneNumbersService;
        const response = await axios.get(
          `/api/admin/userServicesPhoneNumbersForReport?report_type=${this.selectedType}&date=${date}&service_category_and_service_display_name=${service_category_and_service_display_name}`
        );
        this.phoneNumbers = response.data;
      } catch (error) {
        console.log(error);
      } finally {
        this.loadingPhoneNumbers = false;
      }
    },

    refreshReports() {
      this.$store.dispatch("setNullToReports");
    },
    getReportTypes() {
      const url = `/api/admin/reportTypes`;
      axios.get(url).then((response) => {
        this.reportTypes = response.data;
        if (
          this.paymentTypesAmountsReport &&
          this.paymentTypesAmountsReport[0]
        ) {
          const additionalData =
            this.paymentTypesAmountsReport[0].additional_data_list[0];
          this.frozenMoney = parseFloat(additionalData.FROZEN_MONEY);
          this.waitingWithdraws = parseFloat(additionalData.WAITING_WITHDRAWS);
          this.returnedDiscounts = parseFloat(
            additionalData.RETURNED_DISCOUNTS
          );
        }
      });
    },

    async showHealthDataConsentsReport() {
      this.resetAllReports();
      this.healthDataConsentsReportList = await this.$store.dispatch(
        "fetchHealthDataConsentsReport"
      );
      this.healthDataConsentsReport = true;
    },
    formatWarsawDateTime(value) {
      return shared.formattedWarsawDateTime(value);
    },

    resetAllReports() {
      this.healthDataConsentsReport = false;
      this.reportData = [];
      this.columns = [];
      this.selectedType = "";
      this.userServicesInSpecifiedCitiesReport = false;
      this.usersAndUserServicesReport = false;
      this.promotionalCodesReport = false;
      this.referralCodesReport = false;
      this.ordersRejectionReport = false;
      this.userSubscriptions = false;
      this.userRegulations = false;
      this.serviceRegulations = false;
      this.usersActivity = false;
      this.adminPermissionSettings = false;
      this.recharges = false;
      this.walletBalances = false;
      this.triedToLoginReport = false;
      this.userSubscriptionsOrders = false;
      this.languagesReport = false;
      this.trainingsReport = false;
      this.cvsReport = false;
      this.profileFeaturesReport = false;
      this.smsReport = false;
      this.usersAndOrdersReport = false;
      this.ordersByStatusReport = false;
      this.onlyAutoOrdersRejection = false;
      this.onlyUserOrdersRejection = false;
      this.loadingPhoneNumbers = false;
      this.usersServicesByCityReport = false;
      this.phoneNumbers = [];
      this.usersReportsFromAppReport = false;
      this.dodBillsReport = false;
      this.invoicesReport = false;
      this.invoicesVerifying = false;
    },

    showUserServicesInSpecifiedCitiesReport() {
      this.resetAllReports();
      this.userServicesInSpecifiedCitiesReport = true;
      if (
        !this.userServicesInSpecifiedCities ||
        this.userServicesInSpecifiedCities.length === 0
      ) {
        this.$store.dispatch("fetchUserServicesInSpecifiedCityReport");
      }
    },
    showUsersAndUserServicesReport() {
      this.resetAllReports();
      this.usersAndUserServicesReport = true;
      if (
        !this.usersAndUserServices ||
        this.usersAndUserServices.length === 0
      ) {
        this.$store.dispatch("fetchTotalUserAndUserServicesReport");
      }
    },
    showPromotionalCodesReport() {
      this.resetAllReports();
      this.promotionalCodesReport = true;
      const onlyUsedCodes = this.toggleOnlyUsedPromotionalCodes;
      this.$store.dispatch("fetchPromotionalCodesReport", {
        only_used: onlyUsedCodes,
      });
    },
    showReferralCodesReport() {
      this.resetAllReports();
      this.referralCodesReport = true;
      if (!this.promotionalCodes || this.promotionalCodes.length === 0) {
        this.$store.dispatch("fetchPromotionalCodesReport", {
          only_used: this.toggleOnlyUsedPromotionalCodes,
        });
      }
    },
    showOrdersRejectionReport() {
      this.resetAllReports();
      this.ordersRejectionReport = true;
      this.$store.dispatch("fetchOrdersRejectionReport", {
        auto_rejected: this.onlyAutoOrdersRejection,
        user_rejected: this.onlyUserOrdersRejection,
      });
    },
    showUserSubscriptions() {
      this.resetAllReports();
      this.userSubscriptions = true;
    },
    // showUserSubscriptionsOrders() {
    //   this.resetAllReports();
    //   this.userSubscriptionsOrders = true;
    // },
    async showUserRegulations() {
      this.resetAllReports();
      this.userRegulations = true;
      if (
        !this.userRegulationsReport ||
        this.userRegulationsReport.length === 0
      ) {
        await this.$store.dispatch("fetchUserRegulationsReport");
      }
    },
    async showServiceRegulations() {
      this.resetAllReports();
      this.serviceRegulations = true;
      if (
        !this.serviceRegulationsReport ||
        this.serviceRegulationsReport.length === 0
      ) {
        await this.$store.dispatch("fetchServiceRegulationsReport");
      }
    },
    async showUsersActivity() {
      this.resetAllReports();

      this.usersActivity = true;
      await this.$store.dispatch("fetchUsersActivityReport");
    },
    async showAdminPermissionSettings() {
      this.resetAllReports();
      this.adminPermissionSettings = true;
      await this.$store.dispatch("fetchAdminPermissionSettingsReport");
    },
    async showRecharges() {
      this.resetAllReports();
      this.recharges = true;
      await this.$store.dispatch("fetchRechargesReport");
    },
    async showWalletBalances() {
      this.resetAllReports();
      this.walletBalances = true;
      await this.$store.dispatch("fetchWalletBalancesReport");
    },
    async showTriedToLoginReport() {
      this.resetAllReports();
      this.triedToLoginReport = true;
      await this.$store.dispatch("getAllProfilesWhoTriedToLogIn", {
        page_number: 1,
        on_page: 1000000,
      });
    },

    async showProfileElementsReport(type, withoutReset) {
      if (!withoutReset) {
        this.resetAllReports();
      }

      await this.$store.dispatch("fetchProfileElementsReport", {
        type,
        service_category_display_name: this.cvsReportServiceCategorySearchValue,
        service_subcategory_display_name:
          this.cvsReportServiceSubcategorySearchValue,
        service_display_name: this.cvsReportServiceSearchValue,
        city: this.cvsReportCitySearchValue,
      });
      if (type === "PROFILE_FEATURE") {
        this.profileFeaturesReport = true;
        this.languagesReport = false;
        this.trainingsReport = false;
        this.cvsReport = false;
      }
      if (type === "LANGUAGES") {
        this.languagesReport = true;
        this.profileFeaturesReport = false;
        this.trainingsReport = false;
        this.cvsReport = false;
      }
      if (type === "TRAINING") {
        this.trainingsReport = true;
        this.profileFeaturesReport = false;
        this.languagesReport = false;
        this.cvsReport = false;
      }
      if (type === "CVS") {
        this.cvsReport = true;
        this.languagesReport = false;
        this.trainingsReport = false;
        this.profileFeaturesReport = false;
      }
    },

    async showSmsReport() {
      this.resetAllReports();
      this.smsReport = true;

      await this.$store.dispatch("fetchSmsReport");
    },
    async showUsersAndOrdersReport() {
      this.resetAllReports();
      this.usersAndOrdersReport = true;
      await this.$store.dispatch("fetchUsersAndOrdersReport");
    },

    async showOrdersByStatusReport() {
      this.resetAllReports();
      this.ordersByStatusReport = true;
      await this.$store.dispatch("fetchOrdersByStatusReport");
    },

    async showUsersServicesByCityReport(
      service_category_display_name,
      service_subcategory_display_name,
      service_display_name,
      city
    ) {
      this.resetAllReports();
      this.usersServicesByCityReport = true;
      await this.$store.dispatch("fetchUsersServicesByCityReport", {
        service_category_display_name,
        service_subcategory_display_name,
        service_display_name,
        city,
      });
    },

    async showUsersReportFromAppReport() {
      this.resetAllReports();
      this.usersReportsFromAppReport = true;
      await this.$store.dispatch("fetchUsersReportsFromAppReport");
    },

    async showDodBillsReport() {
      this.resetAllReports();
      this.dodBillsReport = true;
      await this.fetchDodBillsReport();
    },

    async fetchDodBillsReport() {
      await this.$store.dispatch("fetchDodBillsReport", {
        year: this.dodBillsYear,
        month: this.dodBillsMonth,
      });
    },

    async showInvoicesReport() {
      this.resetAllReports();
      this.invoicesReport = true;
      await this.fetchInvoicesReport();
    },

    async fetchInvoicesReport() {
      await this.$store.dispatch("fetchInvoicesReport", {
        year: this.invoicesYear,
        month: this.invoicesMonth,
      });
      // Numer faktury czytamy z bazy (payments_admin.invoice_number). Fakturownię odpytujemy w tle
      // TYLKO gdy jakaś przesłana faktura nie ma jeszcze numeru w bazie (po backfillu = 0 wywołań).
      const rows = this.invoicesReportList || [];
      const needsNumbers = rows.some(
        r => r.status === "PRZESLANO" && !r.invoiceNumber
      );
      if (needsNumbers) {
        this.verifyInvoices();
      }
    },

    async verifyInvoices() {
      this.invoicesVerifying = true;
      try {
        await this.$store.dispatch("verifyInvoicesReport", {
          year: this.invoicesYear,
          month: this.invoicesMonth,
        });
      } finally {
        this.invoicesVerifying = false;
      }
    },

    statusClass(status) {
      if (status === "PRZESLANO") return "invoiceStatus--sent";
      if (status === "NIEPRZESLANA") return "invoiceStatus--unsent";
      return "invoiceStatus--missing";
    },

    async copyText(text) {
      const selBox = document.createElement("textarea");
      selBox.style.position = "fixed";
      selBox.style.left = "0";
      selBox.style.top = "0";
      selBox.style.opacity = "0";
      selBox.value = text;
      document.body.appendChild(selBox);
      selBox.focus();
      selBox.select();
      document.execCommand("copy");
      document.body.removeChild(selBox);
      this.$notify({
        group: "success",
        text: "ID zamówienia zostało skopiowane",
      });
    },

    async getReport(type) {
      this.resetAllReports();
      if (type === "VERIFIED_USERS") {
        if (this.verifiedUsersReport.length === 0) {
          await this.$store.dispatch("fetchReport", {
            type: type,
          });
        }
        this.reportData = this.verifiedUsersReport;
        this.columns = this.verifiedUsersColumns;
        this.selectedType = type;
      }
      if (type === "REFERRAL_CODES") {
        if (this.referralCodesReport.length === 0) {
          await this.$store.dispatch("fetchReport", {
            type: type,
          });
        }
        this.reportData = this.referralCodesReport;
        this.columns = this.referralCodesColumns;
        this.selectedType = type;
      }
      if (type === "DATE_OF_BIRTH") {
        if (this.dateOfBirthReport.length === 0) {
          await this.$store.dispatch("fetchReport", {
            type: type,
          });
        }
        this.reportData = this.dateOfBirthReport;
        this.columns = this.dateOfBirthColumns;
        this.selectedType = type;
      }
      if (type === "WORK_STATUS") {
        if (this.workStatusReport.length === 0) {
          await this.$store.dispatch("fetchReport", {
            type: type,
          });
        }
        this.reportData = this.workStatusReport;
        this.columns = this.workStatusColumns;
        this.selectedType = type;
      }
      if (type === "USER_SERVICES_VERIFIED") {
        if (this.userServicesVerifiedReport.length === 0) {
          await this.$store.dispatch("fetchReport", {
            type: type,
          });
        }
        this.reportData = this.userServicesVerifiedReport;
        this.columns = this.userServicesVerifiedColumns;
        this.selectedType = type;
      }
      if (type === "USER_SERVICES") {
        if (this.userServicesReport.length === 0) {
          await this.$store.dispatch("fetchReport", {
            type: type,
          });
        }
        this.reportData = this.userServicesReport;
        this.columns = this.userServicesColumns;
        this.selectedType = type;
      }
      if (type === "USER_SERVICES_PRICE") {
        if (this.userServicesPriceReport.length === 0) {
          await this.$store.dispatch("fetchReport", {
            type: type,
          });
        }
        this.reportData = this.userServicesPriceReport;
        this.columns = this.userServicesPriceColumns;
        this.selectedType = type;
      }
      if (type === "LOCATION") {
        if (this.locationReport.length === 0) {
          await this.$store.dispatch("fetchReport", {
            type: type,
          });
        }
        this.reportData = this.locationReport;
        this.columns = this.locationColumns;
        this.selectedType = type;
      }
      if (type === "ORDERS") {
        if (this.ordersReport.length === 0) {
          await this.$store.dispatch("fetchReport", {
            type: type,
          });
        }
        this.reportData = this.ordersReport;
        this.columns = this.ordersColumns;
        this.selectedType = type;
      }
      if (type === "ORDERS_CRS") {
        if (this.ordersCrsReport.length === 0) {
          await this.$store.dispatch("fetchReport", {
            type: type,
          });
        }
        this.reportData = this.ordersCrsReport;
        this.columns = this.ordersCrsColumns;
        this.selectedType = type;
      }
      if (type === "PAYMENT_TYPES") {
        if (this.paymentTypesReport.length === 0) {
          await this.$store.dispatch("fetchReport", {
            type: type,
          });
        }
        this.reportData = this.paymentTypesReport;
        this.columns = this.paymentTypesColumns;
        this.selectedType = type;
      }
      if (type === "PAYMENT_TYPES_AMOUNTS") {
        if (this.paymentTypesAmountsReport.length === 0) {
          await this.$store.dispatch("fetchReport", {
            type: type,
          });
        }
        this.reportData = this.paymentTypesAmountsReport;
        this.columns = this.paymentTypesAmountsColumns;
        this.selectedType = type;
      }
      if (type === "LOCATION_CITY") {
        if (this.locationCityReport.length === 0) {
          await this.$store.dispatch("fetchReport", {
            type: type,
          });
        }
        this.reportData = this.locationCityReport;
        this.columns = this.locationCityColumns;
        this.selectedType = type;
      }
      if (type === "SERVICE_SEARCH") {
        if (this.serviceSearchReport.length === 0) {
          await this.$store.dispatch("fetchReport", {
            type: type,
          });
        }
        this.reportData = this.serviceSearchReport;
        this.columns = this.serviceSearchColumns;
        this.selectedType = type;
      }
    },

    findMaxLength() {
      this.columns = this.reportData[0].results;
    },

    downloadReport(selectedType) {
      let url;
      if (selectedType === "userServicesInSpecifiedCities") {
        url = `api/admin/employeesInSpecificArea/file`;
      } else if (selectedType === "other") {
        if (this.userServicesInSpecifiedCitiesReport) {
          url = "api/admin/employeesInSpecificArea/file";
        } else if (this.usersAndUserServicesReport) {
          url = "api/admin/totalUsersAndUserServices/file";
        } else if (this.promotionalCodesReport) {
          url = `api/admin/promotionalCodes/file?only_used=${this.toggleOnlyUsedPromotionalCodes} `;
        } else if (this.referralCodesReport) {
          url = `api/admin/promotionalCodes/file?only_used=${this.toggleOnlyUsedPromotionalCodes} `;
        } else if (this.ordersRejectionReport) {
          url = `api/admin/rejectedOrders/report?auto_rejected=${this.onlyAutoOrdersRejection}&user_rejected=${this.onlyUserOrdersRejection}`;
        } else if (this.userSubscriptions) {
          this.downloadSubscriptionsReport();
          return;
        } else if (this.userSubscriptionsOrders) {
          this.downloadSubscriptionsOrdersReport();
          return;
        } else if (this.userRegulations) {
          url = "api/admin/userRegulations/file";
        } else if (this.serviceRegulations) {
          url = "api/admin/userServicesRegulations/file";
        } else if (this.usersActivity) {
          url = "api/admin/userActivity/file";
        } else if (this.adminPermissionSettings) {
          url = "api/admin/permissionSettings/file";
        } else if (this.recharges) {
          url = "api/admin/rechargeReport/file";
        } else if (this.triedToLoginReport) {
          url = "api/profile/triedToLogIn/file";
        } else if (this.profileFeaturesReport) {
          url = `/api/admin/profileElementsReport/file?type=PROFILE_FEATURE`;
        } else if (this.languagesReport) {
          url = `/api/admin/profileElementsReport/file?type=LANGUAGES`;
        } else if (this.trainingsReport) {
          url = `/api/admin/profileElementsReport/file?type=TRAINING`;
        } else if (this.cvsReport) {
          url = `/api/admin/profileElementsReport/file?type=CVS`;
        }
      } else {
        url = `api/admin/reports/file?report_type=${selectedType}`;
      }

      axios(url, {
        method: "GET",
        headers: {
          "Content-Disposition": "attachment; filename=reports.xls",
          "Content-Type":
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        },
        responseType: "blob",
      })
        .then((response) => {
          const fileURL = window.URL.createObjectURL(new Blob([response.data]));
          const fileLink = document.createElement("a");

          fileLink.href = fileURL;
          fileLink.setAttribute(
            "download",
            selectedType.toLowerCase() + ".xls"
          );
          document.body.appendChild(fileLink);

          fileLink.click();
        })
        .catch((err) => console.log(err.response));
    },
  },

  computed: {
    filteringParams() {
      return this.$store.getters.getFilteringParams;
    },
    // subscriptionReport() {
    //   let reports = this.$store.getters.getSubscriptionReport;
    //   reports.forEach((r) => {
    //     if (!this.addedMainRow[`${r.orderId}`]) {
    //       this.addedMainRow[`${r.orderId}`] = 1;
    //       r.isMainRow = true;
    //     } else {
    //       r.isMainRow = false;
    //       this.addedMainRow[`${r.orderId}`] =
    //         this.addedMainRow[`${r.orderId}`] + 1;
    //     }
    //   });

    //   return reports;
    // },
    subscriptionOrdersReport() {
      let reports = this.$store.getters.getSubscriptionOrdersReport;
      return reports;
    },
    usersAndUserServices() {
      return this.$store.getters.getTotalUsersAndUserServiceReport;
    },
    ordersRejection() {
      return this.$store.getters.getOrdersRejectionReport;
    },
    promotionalCodes() {
      return this.$store.getters.getPromotionalCodesReport;
    },
    userServicesInSpecifiedCities() {
      return this.$store.getters.getUserServicesInSpecifiedCityReport;
    },
    verifiedUsersReport() {
      return this.$store.getters.getVerifiedUsersReport;
    },
    verifiedUsersColumns() {
      return this.$store.getters.getVerifiedUsersColumns;
    },

    // referralCodesCounterReport() {
    //   return this.$store.getters.getReferralCodesReport;
    // },
    referralCodesColumns() {
      return this.$store.getters.getReferralCodesColumns;
    },

    dateOfBirthReport() {
      return this.$store.getters.getDateOfBirthReport;
    },
    dateOfBirthColumns() {
      return this.$store.getters.getDateOfBirthColumns;
    },

    workStatusReport() {
      return this.$store.getters.getWorkStatusReport;
    },
    workStatusColumns() {
      return this.$store.getters.getWorkStatusColumns;
    },

    userServicesReport() {
      return this.$store.getters.getUserServicesReport;
    },
    userServicesColumns() {
      return this.$store.getters.getUserServicesColumns;
    },

    serviceSearchReport() {
      return this.$store.getters.getServiceSearchReport;
    },
    serviceSearchColumns() {
      return this.$store.getters.getServiceSearchColumns;
    },

    userServicesVerifiedReport() {
      return this.$store.getters.getUserServicesVerifiedReport;
    },
    userServicesVerifiedColumns() {
      return this.$store.getters.getUserServicesVerifiedColumns;
    },

    userServicesPriceReport() {
      return this.$store.getters.getUserServicesPriceReport;
    },
    userServicesPriceColumns() {
      return this.$store.getters.getUserServicesPriceColumns;
    },

    locationReport() {
      return this.$store.getters.getLocationReport;
    },
    locationColumns() {
      return this.$store.getters.getLocationColumns;
    },

    locationCityReport() {
      return this.$store.getters.getLocationCityReport;
    },
    locationCityColumns() {
      return this.$store.getters.getLocationCityColumns;
    },

    ordersReport() {
      return this.$store.getters.getOrdersReport;
    },
    ordersColumns() {
      return this.$store.getters.getOrdersColumns;
    },

    ordersCrsReport() {
      return this.$store.getters.getOrdersCrsReport;
    },
    ordersCrsColumns() {
      return this.$store.getters.getOrdersCrsColumns;
    },

    paymentTypesReport() {
      return this.$store.getters.getPaymentTypesReport;
    },
    paymentTypesColumns() {
      return this.$store.getters.getPaymentTypesColumns;
    },

    paymentTypesAmountsReport() {
      return this.$store.getters.getPaymentTypesAmountsReport;
    },
    paymentTypesAmountsColumns() {
      return this.$store.getters.getPaymentTypesAmountsColumns;
    },
    userRegulationsReport() {
      return this.$store.getters.getUserRegulationsReport;
    },
    serviceRegulationsReport() {
      return this.$store.getters.getServiceRegulationsReport;
    },
    usersActivityReport() {
      return this.$store.getters.getUsersActivityReport;
    },
    adminPermissionSettingsReport() {
      return this.$store.getters.getAdminPermissionSettingsReport;
    },
    rechargesReport() {
      return this.$store.getters.getRechargesReport;
    },
    walletBalancesReport() {
      return this.$store.getters.getWalletBalancesReport;
    },
    usersWhoTriedToLogIn() {
      return this.$store.getters.getUsersWhoTriedToLogIn;
    },
    languagesReportList() {
      return this.$store.getters.getLanguagesReport;
    },
    profileFeaturesReportList() {
      return this.$store.getters.getProfileFeaturesReport;
    },
    trainingsReportList() {
      return this.$store.getters.getTrainingsReport;
    },
    cvsReportList() {
      return this.$store.getters.getCvsReport;
    },
    smsReportList() {
      return this.$store.getters.getSmsReport;
    },
    usersAndOrdersList() {
      return this.$store.getters.getUsersAndOrdersReport;
    },
    ordersByStatusList() {
      return this.$store.getters.getOrdersByStatusReport;
    },
    usersServicesByCityList() {
      return this.$store.getters.getUsersServicesByCityReport;
    },
    usersReportsFromAppList() {
      return this.$store.getters.getUsersReportsFromAppReport;
    },
    dodBillsReportList() {
      return this.$store.getters.getDodBillsReport;
    },
    dodBillsYear() {
      return this.dodBillsSelectedDate
        ? this.dodBillsSelectedDate.getFullYear()
        : new Date().getFullYear();
    },
    dodBillsMonth() {
      return this.dodBillsSelectedDate
        ? this.dodBillsSelectedDate.getMonth() + 1
        : new Date().getMonth() + 1;
    },
    invoicesReportList() {
      return this.$store.getters.getInvoicesReport;
    },
    invoicesSummary() {
      const rows = this.invoicesReportList || [];
      let sent = 0;
      let unsent = 0;
      let missing = 0;
      let sumBrutto = 0;
      rows.forEach(r => {
        if (r.status === "PRZESLANO") sent += 1;
        else if (r.status === "NIEPRZESLANA") unsent += 1;
        else if (r.status === "NIEWYSTAWIONA") missing += 1;
        sumBrutto += r.grossAmount || 0;
      });
      return {
        total: rows.length,
        sent,
        unsent,
        missing,
        sumBrutto: sumBrutto.toFixed(2),
      };
    },
    invoicesYear() {
      return this.invoicesSelectedDate
        ? this.invoicesSelectedDate.getFullYear()
        : new Date().getFullYear();
    },
    invoicesMonth() {
      return this.invoicesSelectedDate
        ? this.invoicesSelectedDate.getMonth() + 1
        : new Date().getMonth() + 1;
    },
  },
};
</script>

<style scoped>
h5 {
  text-align: left;
}
.refreshIcon {
  font-size: 20px;
  cursor: pointer;
  color: #090741;
}
.reportTable tr {
  border: none;
}
.reportTypeButton {
  margin: 5px;
}
.reportTypeButton:hover {
  margin: 5px;
}
.selectReport {
  display: flex;
  justify-content: center;
  margin-bottom: 30px;
  flex-wrap: wrap;
  color: #090741;
}
.downloadButton {
  border-radius: 10px;
  width: 100%;
}
.id-column img {
  width: 18px;
  height: 18px;
}
.invoicesSummary {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px;
  margin: 10px 0 16px;
}
.invoicesSummary .summaryItem {
  font-size: 13px;
}
.invoicesSummary .summaryItem b {
  font-size: 15px;
}
.invoiceStatus {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 10px;
  font-size: 11px;
  font-weight: 600;
  white-space: nowrap;
}
.invoiceStatus--sent {
  background: #d4edda;
  color: #155724;
}
.invoiceStatus--unsent {
  background: #fff3cd;
  color: #856404;
}
.invoiceStatus--missing {
  background: #f8d7da;
  color: #721c24;
}
.fa-info-circle {
  color: rgb(116, 108, 108);
  font-size: 20px;
  position: relative;
}
.fa-info-circle:hover {
  cursor: pointer;
}
.dailyTable {
  position: absolute;
  width: 180px;
  left: 30px;
  bottom: -36px;
  z-index: 40000;
  font-size: 10px !important;
}
.dailyTable td {
  padding: 0;
  margin: 0;
}
.dailyTable table {
  position: relative;
}
.dailyTable table i {
  position: absolute;
  top: 3px;
  left: 3px;
  font-size: 8px;
}
.dateColumn {
  position: relative;
}
.dailyTable table {
  border-radius: 0;
}
.phoneNumbersList {
  font-size: 12px;
}
.toggle {
  margin-right: 10px;
  align-items: center;
  display: flex;
}
.toggle i {
  font-size: 18px;
  cursor: pointer;
  margin: 0;
  margin-right: 1rem;
}
.df {
  display: flex;
}
.adjust-height {
  height: 30px;
  margin-top: 15px;
}
.btn-styles {
  background: #090741;
  color: white;
  height: 25px;
  margin-top: 18px;
}
.btn-styles:hover {
  background: #fb8929;
}

.orders-by-status-year-row {
  background: rgb(203, 201, 201);
  border-radius: 0px 0px 0px 0px !important;
  font-weight: bold;
}
.orders-by-status-yellow-row {
  background: rgb(253, 253, 30);
}
.not-renewed {
  background: rgba(226, 3, 126, 0.07);
}
.usersServicesByCityListCounter {
  display: flex;
  align-items: center;
}
.btn-outline-dark,
.btn-outline-dark:hover {
  margin-left: 0px;
}
.arrow-icon {
  cursor: pointer;
  font-size: 20px;
}
</style>
